import { useEffect } from "react";
import { notification } from "antd";
import {Trans, useTranslation} from "react-i18next";
import Cookies from "js-cookie";

const ConsentNoticeNotification = () => {
    const [api, contextHolder] = notification.useNotification();
    const { t } = useTranslation();

    useEffect(() => {
        if (!Cookies.get("cookie-consent-shown")) {
            api.info({
                message: t("cookieTitle"),
                description: (
                    <Trans
                        i18nKey="consentNotice"
                        components={{
                            anchorlink: <a href="https://laone.ru/include/licenses_detail.php" target="_blank" rel="noopener noreferrer"></a>
                        }}
                    />
                ),
                placement: "bottom",
                icon: <span role="img" aria-label="cookie">🍪</span>,
                duration: 0,
                style: {
                    width: '1000px',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                },
                onClose: () => {
                    Cookies.set("cookie-consent-shown", "true", { expires: 7 });
                },
            });

        }
    }, [api]);

    return <>{contextHolder}</>;
};

export default ConsentNoticeNotification;